import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {T} from '../../../utils/I18n/I18n';
import './ProductSidebarDeliveryAccordion.scss';
import readConfig from '../../../utils/readClientConfiguration';
import productionConfiguration from '../../../config/default.json';
import Availablity from "../Availablity/Availablity";
import {useLazyQuery} from "@apollo/client";
import {AVAILABILITY_QUERY} from "../../../queries/product";
import { Trans, useTranslation } from 'react-i18next';
const phoneSupportNumber = readConfig(productionConfiguration, 'phoneSupportNumber');
const phoneSupportWorkHours = readConfig(productionConfiguration, 'phoneSupportWorkHours');
const phoneSupportWorkHoursWeekend = readConfig(productionConfiguration, 'phoneSupportWorkHoursWeekend');

const freePickup = "https://s3.emmezeta.hr/falcon/free_pickup.svg";
const location = 'https://s3.emmezeta.hr/falcon/location.svg';
const downArrow = 'https://s3.emmezeta.hr/falcon/down_arrow.svg';
const email = 'https://s3.emmezeta.hr/falcon/email.svg';
const phone = 'https://s3.emmezeta.hr/falcon/phone.svg';

const ProductSidebarDeliveryAccordion = ({product}) => {
  const { t } = useTranslation();
  const [active, setIsActive] = useState(false);
  const {__typename, canonical_url, sku, name} = product
  const [getAvailablity, {loading, data}] = useLazyQuery(AVAILABILITY_QUERY, {
    onCompleted: (data) => {

      setAvailability(data.storeAvailability.filter(({qtyAvailable, deliveryQty}) => {
        return qtyAvailable > 0 || deliveryQty > 0
      }));
    }
  });

  const [availability, setAvailability] = useState([]);
  useEffect(() => {
    if (__typename == 'SimpleProduct') {
      getAvailablity(
          {variables: {sku: sku}}
      )
    }
  }, [sku])
  const toggleAccordion = () => {
    setIsActive(prev => !prev);
  };

  if (availability.length == 0) {
    return null;
  }
  return (
      <>
        {/*<div className="delivery-options">*/}
        {/*  <img src={freePickup} alt="" className="delivery-options__icon"/>*/}
        {/*  <div>*/}
        {/*    <T id="product.onlineOrder"/>*/}
        {/*    <span className="delivery-options__free">*/}
        {/*      <T id="product.onlineOrderFree"/>*/}
        {/*  </span>*/}
        {/*    <T id="product.onlineOrder2"/>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="delivery-options">
          <div className="delivery-accordion">
            <div
                className="delivery-accordion__tab"
                onClick={toggleAccordion}
            >
              <img src={freePickup} alt="" className="delivery-options__icon"/>
              <div>
                {/*<T id="Availability for purchase at branches"/>*/}
                <Trans i18nKey="Availability for purchase at branches" />
              </div>
              <img
                  className={`delivery-accordion__tab-arrow delivery-accordion__tab-arrow_${active}`}
                  src={downArrow}
                  alt=""
              />
            </div>
            <div className={`delivery-accordion__content delivery-accordion__content_${active}`}>
              <Availablity availbility={availability}/>

              <div className="delivery-accordion__details">
                <div>
                  <T id="product.queryAboutAvailability"/>
                </div>
                <div className="delivery-accordion__details-row">
                  <img src={email} alt="delivery-form-contact" className="delivery-accordion__details-row-icon"/>
                  <Link
                      className="delivery-accordion__details-link"
                      to={`/emmezeta-pitanja-o-proizvodu?productSku=${sku}&productName=${name}`}
                      rel="nofollow"
                  >
                    <T id="product.supportViaForm"/>
                  </Link>
                </div>
                <div className="delivery-accordion__details-row">
                  <img src={phone} alt="delivery-phone-info" className="delivery-accordion__details-row-icon"/>
                  <div>
                    <a href={`tel:${phoneSupportNumber}`}>{phoneSupportNumber}</a>
                    <p>{phoneSupportWorkHours}</p>
                    {phoneSupportWorkHoursWeekend && (
                        <p>{phoneSupportWorkHoursWeekend}</p>
                    )}
                    <p>
                      <T id="product.phoneSupportDetails"/>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default ProductSidebarDeliveryAccordion;
